import { memo } from "react";
import { CartesianGrid, Legend, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const eur = (v) => (v == null ? "n/c" : `${Math.round(v).toLocaleString("fr-FR")} €`);
const short = (v) => (Math.abs(v) >= 1000 ? `${Math.round(v / 1000)} k€` : `${v} €`);
const CHART_MARGIN = { top: 10, right: 20, left: 10, bottom: 0 };
const AXIS_TICK = { fontSize: 12 };
const TOOLTIP_STYLE = { borderRadius: 8, fontSize: 12 };
const LEGEND_STYLE = { fontSize: 12 };
const DOT = { r: 4 };

function TresorerieChart({ chart, horizonLabel }) {
    const data = (chart?.mois || []).filter((m) => m.sans_rj != null || m.avec_rj != null);
    if (data.length < 2) return null;
    return (
        <div data-testid="tresorerie-chart" className="space-y-2">
            <div className="flex flex-wrap items-baseline justify-between gap-2">
                <h4 data-testid="tresorerie-chart-title" className="font-display text-base text-foreground">Trajectoire de trésorerie cumulée{horizonLabel ? ` — ${horizonLabel}` : ""}</h4>
                {chart.rupture_sans_rj && <span data-testid="tresorerie-rupture" className="text-xs font-semibold text-rose-700">Rupture sans RJ : {chart.rupture_sans_rj}</span>}
            </div>
            <div className="h-72 w-full">
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={data} margin={CHART_MARGIN}>
                        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                        <XAxis dataKey="label" tick={AXIS_TICK} stroke="hsl(var(--muted-foreground))" />
                        <YAxis tickFormatter={short} tick={AXIS_TICK} stroke="hsl(var(--muted-foreground))" width={70} />
                        <Tooltip formatter={(v) => eur(v)} contentStyle={TOOLTIP_STYLE} />
                        <Legend wrapperStyle={LEGEND_STYLE} />
                        <ReferenceLine y={0} stroke="hsl(var(--foreground))" strokeWidth={1} />
                        <Line type="monotone" dataKey="sans_rj" name="Sans RJ (poursuite du passif)" stroke="#B91C1C" strokeWidth={2.5} dot={DOT} connectNulls />
                        <Line type="monotone" dataKey="avec_rj" name="Avec RJ (gel du passif)" stroke="#047857" strokeWidth={2.5} dot={DOT} connectNulls />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

// LOT 47 : mémoïsé — ne se re-rend que lorsque `chart` (données différées 500 ms) change réellement.
export default memo(TresorerieChart);
